
import { Vue, Component } from 'vue-property-decorator';

import bus from '@/core/bus';
import { BusConstants, HomePaths, ModalConstants } from '@/core/constants';
import { WebsiteAction } from '@/types/apiServerContract';

export const actionOptions: any[] = [
    {
        value: 0,
        text: 'None'
    },
    {
        value: 1,
        text: 'Show Register Overlay'
    }
];

@Component
export default class WebsiteActions extends Vue {
    public executeAction(action: WebsiteAction) {
        switch (action) {
        case WebsiteAction.Register:
            bus.emit(BusConstants.Register, HomePaths.Index);
            this.$bvModal.show(ModalConstants.Register);
            break;
        }
    }
}
